// Module
var code = "<div class=\"dtp-chart-wrapper\"> <canvas class=\"chart chart-bar\" chart-data=\"$ctrl.dataToPPGChart\" chart-labels=\"$ctrl.labels\" chart-options=\"$ctrl.chartOptions\" chart-series=\"$ctrl.series\" chart-dataset-override=\"$ctrl.datasetOverride\"></canvas> </div>";
// Exports
module.exports = code;